import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  AbstractControl,
  UntypedFormArray,
  UntypedFormControl,
} from "@angular/forms";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

import { CustomModalPopupComponent } from "../custom-modal-popup/custom-modal-popup.component";
import { GSFReport } from "../GSF-report.service";
import { ActivityModelNew } from "../models/newChanges";
import { DuplicateCheckService } from "../service/duplicate-check.service";
import { CalculateInputFormateService } from "../service/calculate-input-formate.service";
import { ReportCalculateService } from "../service/report-calculate.service";
import { CONSTANTS } from "../models/constant.model";

@Component({
  selector: "app-calc-activity",
  templateUrl: "./activity.component.html",
  styleUrls: ["./activity.component.css"],
})
export class CalcActivityComponent implements OnInit {
  @Input()
  activityForm: UntypedFormGroup;
  @Input()
  activity: ActivityModelNew;
  @Input()
  pillarName: string;

  questionCopy: string;
  @Output()
  modifiedActivity: EventEmitter<number> = new EventEmitter();
  private count = 0;

  @Output()
  errorInActivityCalcComp: EventEmitter<string> = new EventEmitter();
  public imgHelpDialog = false;
  public chainaHelpDialog = false;
  public chinaControl: UntypedFormControl;
  private hasDuplicateNotApplicable = false;
  public classApplied = false;
  constructor( //nosonar
    public translate: TranslateService, //nosonar
    public report: GSFReport,
    private readonly calInpFormat: CalculateInputFormateService,
    private readonly dupCheckService: DuplicateCheckService,
    private readonly fb: UntypedFormBuilder,
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly calService: ReportCalculateService
  ) { //nosonar
    translate.setDefaultLang("eng");
  } // nosonar

  ngOnInit() {
    this.chinaControl = this.fb.control(0);
    this.chinaControl.setValidators(validateChinaContribution);
    this.activity.questionEntryJson = {};
    this.questionCopy = JSON.parse(
      JSON.stringify(this.activity.questionList[0])
    );
  }
  private openWarningDialog(label: string): Observable<boolean> {
    const dialogRef = this.dialog.open(CustomModalPopupComponent, {
      data: { label },
    });
    return dialogRef.afterClosed();
  }
  public addCalculator() {
    if (this.hasActivityFormValid()) {
      const question = JSON.parse(JSON.stringify(this.questionCopy));
      question["status"] = CONSTANTS.CREATE;
      delete question.reportDetailGSFId;
      delete question.subTotalReport;
      this.removeGSfCalDetailsId(question.inputList);
      this.activity.questionList.push(question);
      const questionList = this.activityForm.get(
        CONSTANTS.QUESTIONLIST
      ) as UntypedFormArray;
      questionList.push(this.createQuestionFormGroup(question));
      this.count++;
      this.modifiedActivity.emit(this.count);
    } else {
      this.snackBar.open(this.translate.instant("Savings"), "OK", {
        duration: 10000,
      });
    }
  }

  public setActivityStatus(status: string): void {
    this.activity.status = status;
  }

  public errorInActivityComponent(e): void {
    this.errorInActivityCalcComp.emit(e);
  }
  public openImage(): void {
    this.imgHelpDialog = true;
  }
  public closeImageModal(): void {
    this.imgHelpDialog = false;
  }

  public chainaHelp(): void {
    this.chainaHelpDialog = true;
  }

  public closeChinaHelpDialog(): void {
    this.chainaHelpDialog = false;
  }

  public remove(index): void {
    if (index !== 0) {
      this.activityForm.markAsTouched();
      const lastQuestion = this.activity.questionList[index];
      lastQuestion.status = CONSTANTS.DELETE;
      delete this.activity["questionEntryJson"][index];
      this.dupCheckService.checkDuplicateEntryInActivityLevel(
        this.activityForm,
        this.activity
      );
    }
  }

  public onSubmit(): void {
    this.makeQuestionListTouched();
    if (this.hasActivityFormValid()) {
      if (this.activity["errors"] && this.activity["errors"]["flag"]) {
        this.snackBar.open(this.activity["errors"]["msg"], "OK", {
          duration: 10000,
        });
      } else {
        this.calculateReport();
      }
    }
  }

  private calculateReport(): void {
    const reportCalInputListQuesWise = this.calInpFormat.getInputListQuestionWise(
      this.activity,
      this.getActivityId(),
      this.pillarName
    );
    if (this.checkNotApplicable(reportCalInputListQuesWise)) {
      this.errorInActivityCalcComp.emit(
        this.translate.instant("CalculatedValueNegative")
      );

      this.snackBar.open(
        this.translate.instant("CalculatedValueNegative"),
        "OK",
        {
          duration: 10000,
        }
      );
    } else {
      this.processApplicableItem(reportCalInputListQuesWise);
      this.count++;
      this.modifiedActivity.emit(this.count);
    }
  }

  private processApplicableItem(reportCalInputListQuesWise: any[]) {
    const activityCalInp = {
      activityId: this.activity.id,
      questionList: reportCalInputListQuesWise,
    };
    this.calService.getCalculateResult([activityCalInp]).subscribe(
      (result) => {
        this.populateCalResult(result);
        if (this.activity["totalReport"] <= 0 && this.activity["totalReportSL"] <= 0 && this.activity["totalReportSO"] <= 0
          && !this.activity.hasNoGHGemission && !this.activity.acceptZero) {
          if (this.activity.showTotalReportWarning) {
            this.openWarningDialog(
              this.activity.totalReportWarningMessage
                ? this.activity.totalReportWarningMessage
                : ""
            );
          }
          this.report.gsfValid = false;
          this.errorInActivityCalcComp.emit(
            this.translate.instant("CalculatedValueNegative")
          );
          this.snackBar.open(
            this.translate.instant("CalculatedValueNegative"),
            "OK",
            {
              duration: 10000,
            }
          );
        } else {
          this.report.gsfValid = true;
        }
      },
      (error) => {
        this.report.gsfValid = false;
        this.errorInActivityCalcComp.emit(
          this.translate.instant("ErrorInCalculation")
        );
        this.snackBar.open(
          this.translate.instant("ErrorInCalculation"),
          "OK",
          {
            duration: 10000,
          }
        );
      }
    );
  }

  private checkNotApplicable(reportCalInputListQuesWise): boolean {
    this.hasDuplicateNotApplicable = false;
    if (
      this.activity.checkNotApplicable &&
      reportCalInputListQuesWise &&
      reportCalInputListQuesWise.length > 0
    ) {
      reportCalInputListQuesWise.forEach((data) => {
        const inputSet = new Set();
        if (data.inputList && data.inputList.length > 0) {
          this.checkInputValue(data.inputList);
          data.inputList.forEach((input) => {
            if (inputSet.has(input)) {
              this.hasDuplicateNotApplicable = true;
              this.activity.totalReport = 0;
            }
            inputSet.add(input);
          });
        }
      });
    }

    return this.hasDuplicateNotApplicable;
  }
  private checkInputValue(inputList): void {
    if (inputList && inputList.length > 0) {
      if (inputList[this.activity.dependencyIndexOne] === "Not Applicable") {
        if (!inputList[this.activity.dependencyIndexTwo]) {
          this.hasDuplicateNotApplicable = true;
          this.activity.totalReport = 0;
        }
      }
      if (inputList[this.activity.dependencyIndexTwo] === "Not Applicable") {
        if (!inputList[this.activity.dependencyIndexOne]) {
          this.hasDuplicateNotApplicable = true;
          this.activity.totalReport = 0;
        }
      }
    }
  }

  private createQuestionFormGroup(question): UntypedFormGroup {
    const questionForm = this.fb.group({
      inputList: this.fb.array([]),
    });

    question.inputList.forEach((input) => {
      if (input.type) {
        (questionForm.get("inputList") as UntypedFormArray).push(
          this.getFormControl()
        );
      }
    });

    return questionForm;
  }

  private getFormControl() {
    return this.fb.control("");
  }

  private hasActivityFormValid() {
    let formValid = true;
    this.activity.questionList.forEach((qus, index) => {
      if (qus.status !== CONSTANTS.DELETE) {
        const qusForm = this.activityForm.get("questionList")["controls"][
          index
        ] as UntypedFormGroup;
        if (qusForm.valid === false) {
          formValid = false;
        }
      }
    });

    return formValid;
  }

  private makeQuestionListTouched(): void {
    const questionFormArray = this.activityForm.get(
      "questionList"
    ) as UntypedFormArray;
    for (const questionForm of questionFormArray.controls) {
      const inputList = questionForm.get("inputList") as UntypedFormArray;
      this.makeInputListTouched(inputList);
    }
  }

  private makeInputListTouched(inputList: UntypedFormArray): void {
    for (const inputCtl of inputList.controls) {
      inputCtl.markAsTouched();
    }
  }

  private getActivityId(): string {
    return this.activity.id;
  }

  private populateCalResult(calResult): void {
    let activityLevelReport = 0;
    let activityLevelReportSL = 0;
    let activityLevelReportSO = 0;
    let i = 0;
    this.activity.questionList.forEach((question, qusInd) => {
      if (question.status !== CONSTANTS.DELETE) {
        const questionResult = calResult[this.activity.id][i];
        question["calResult"] = questionResult;


        question["subTotalReport"] = questionResult.calculatedValue;
        activityLevelReport =
          activityLevelReport + parseFloat(questionResult.calculatedValue);

          /**Spacial Land Result */
        if (questionResult && questionResult.spatialLand) {
          question["calResultSO"] = 0;
          question["subTotalReportSO"] = 0;
          const questionResultSL = questionResult.spatialLand;
          question["calResultSL"] = questionResultSL;
          question["subTotalReportSL"] = questionResultSL.calculatedValue;
          activityLevelReportSL =
            activityLevelReportSL +
            parseFloat(questionResultSL.calculatedValue);
        }

        /**Spacial ocean Result */
        if (questionResult && questionResult.spatialOcean) {
          question["calResultSL"] = 0;
          question["subTotalReportSL"] = 0;

          const questionResultSO = questionResult.spatialOcean;
          question["calResultSO"] = questionResultSO;
          question["subTotalReportSO"] = questionResultSO.calculatedValue;
          activityLevelReportSO =
            activityLevelReportSO +
            parseFloat(questionResultSO.calculatedValue);
        }
        i++;

      }
    });
    this.activity.totalReport = activityLevelReport;
    this.activity["totalReportSL"] = activityLevelReportSL;
    this.activity["totalReportSO"] = activityLevelReportSO;
  }

  private removeGSfCalDetailsId(inputList): void {
    inputList.forEach((input) => {
      delete input["ans"];
      delete input.reportGSFCalcDetailId;
    });
  }

  toggleClass() {
    this.classApplied = !this.classApplied;
  }

  checkResultNoResult(question) {// no sonar
    if (this.activity.acceptZero && question && question.subTotalReport == 0 // no sonar
      && question.subTotalReportSL == 0 && question.subTotalReportSO == 0) { // no sonar
      return true;
    } else {
      return false;
    }
  }
}

export function validateChinaContribution(control: AbstractControl) {
  if (control && control.value) {
    if (control.value > 100) {
      return { errors: true };
    } else {
      return null;
    }
  }
  return null;
}

